import React from 'react';
import CommonPageHeader from '../../../components/CommonPageHeader/CommonPageHeader';
import PageHelmet from '../../../components/shared/PageHelmet';
import MainFooter from '../../../components/MainFooter/MainFooter';
import NavHeader from '../../../components/NavHeader/NavHeader';
import KeyFeatures from '../KeyFeatures/KeyFeatures';
import OurApproach from '../../Home/OurApproach/OurApproach';
import AdditionalServices from '../AdditionalServices/AdditionalServices';
import { LassoSelect, CopySlash, Cone, Contrast, Workflow, SquareMousePointer, SquareUser, Users, Layers, Smartphone, LayoutGrid, PencilRuler } from 'lucide-react';
import OurExpertise from '../../../components/OurExpertise/OurExpertise';
import { Link } from 'react-router-dom';

const OurExpertiseData = [
    {
        id: 1,
        title: "Human-Centered Design Approach",
        icon: <SquareUser size="64" strokeWidth='1' />,
        content: "We craft designs rooted in user research and psychology, ensuring intuitive and enjoyable digital experiences that resonate with your target audience."
    },
    {
        id: 2,
        title: "Cutting-Edge Design Tools",
        icon: <SquareMousePointer size="64" strokeWidth='1' />,
        content: "Leveraging tools like Figma and Adobe XD, we create interactive prototypes and stunning visuals that bring your concepts to life efficiently."
    },
    {
        id: 3,
        title: "UX Research & Discovery",
        icon: <Users size="64" strokeWidth='1' />,
        content: "User interviews, journey mapping, and usability research that ground every design decision in real user needs."
    },
    {
        id: 4,
        title: "Design Systems & Consistency",
        icon: <Layers size="64" strokeWidth='1' />,
        content: "Reusable design systems that keep your web and mobile app design consistent as your product grows."
    }
]

const KeyFeaturesData = [
    {
        id: 1,
        title: "UX Research",
        icon: <Users size="42" strokeWidth='1' />,
        content: "In-depth user research and journey mapping that inform every design decision."
    },
    {
        id: 2,
        title: "Wireframes",
        icon: <LassoSelect size="42" strokeWidth='1' />,
        content: "Clear wireframes that map out structure and flow before visual design begins."
    },
    {
        id: 3,
        title: "UI Design",
        icon: <CopySlash size="42" strokeWidth='1' />,
        content: "Polished, on-brand interfaces designed for clarity and ease of use."
    },
    {
        id: 4,
        title: "Mobile App Design",
        icon: <Smartphone size="42" strokeWidth='1' />,
        content: "Native-feeling mobile app design for iOS and Android."
    },
    {
        id: 5,
        title: "Web Design",
        icon: <LayoutGrid size="42" strokeWidth='1' />,
        content: "Responsive web design that looks and performs great on every device."
    },
    {
        id: 6,
        title: "Design Systems",
        icon: <Layers size="42" strokeWidth='1' />,
        content: "Component libraries and design systems that scale across your product."
    },
    {
        id: 7,
        title: "Prototyping",
        icon: <PencilRuler size="42" strokeWidth='1' />,
        content: "Interactive prototypes that let you test ideas before development begins."
    }
]

const AdditionalServicesData = [
    {
        id: 1,
        title: "Usability Testing",
        icon: <Cone size="54" strokeWidth='1' />,
        content: "Real user feedback to optimize functionality and design."
    },
    {
        id: 2,
        title: "Accessibility Audits",
        icon: <Contrast size="54" strokeWidth='1' />,
        content: "Ensuring compliance with WCAG standards for inclusivity."
    },
    {
        id: 3,
        title: "UI/UX Consulting",
        icon: <Workflow size="54" strokeWidth='1' />,
        content: "Strategic advice and optimization for new or existing projects."
    }
]

const OurApproachData = [
    {
        id: 1,
        title: <h3><Link to="/">Discovery</Link></h3>,
        img: "assets/img/project/discover_icon_white.svg",
        content: "Understand your goals through collaborative sessions."
    },
    {
        id: 2,
        title: <h3><Link to="/">Design</Link></h3>,
        img: "assets/img/project/design_icon_white.svg",
        content: "Deliver wireframes, prototypes, and scalable architectures focused on usability and performance."
    },
    {
        id: 3,
        title: <h3><Link to="/">Development</Link></h3>,
        img: "assets/img/project/develop_icon_white.svg",
        content: "Deliver wireframes, prototypes, and scalable architectures focused on usability and performance."
    },
    {
        id: 4,
        title: <h3><Link to="/">Quality Assurance</Link></h3>,
        img: "assets/img/project/define_icon_white.svg",
        content: "Ensure flawless functionality on all devices and platforms."
    },
    {
        id: 5,
        title: <h3><Link to="/">Launch & Support</Link></h3>,
        img: "assets/img/project/deliver_icon_white.svg",
        content: "Seamless deployment, app store submissions, and ongoing maintenance."
    }
]
const bgColors = ["#006ce0", "#001133", "#006ce0", "#001133", "#006ce0"];

const UIUX = () => {
    return (
        <>
            <PageHelmet
                pageTitle="UI/UX & Product Design"
                description="Human-centered UI/UX & product design services from Harsoft Solutions — UX research, wireframes, design systems, and prototypes for web and mobile app design."
                keywords="UI/UX Design, Product Design, UX Research, Design Systems, Mobile App Development, Web Development Company"
                path="/UIUX"
            />

            <NavHeader />
            <main>
                <CommonPageHeader title="UI/UX & Product Design" subtitle="UI/UX & Product Design" />
                <OurExpertise OurExpertiseData={OurExpertiseData} title="Our Expertise" subtitle="Research-Driven Design, End to End" content="We prioritize user needs and industry best practices through UX research, wireframes, UI design, and design systems. From concept to execution, every design decision is crafted to resonate with your audience and drive results." />
                <KeyFeatures KeyFeaturesData={KeyFeaturesData} />
                <AdditionalServices AdditionalServicesData={AdditionalServicesData} img="assets/img/expart/expart-1.jpg" />
                <OurApproach OurApproachData={OurApproachData} title="Our Process" bgColors={bgColors} />
            </main>
            <MainFooter />
        </>
    );
};

export default UIUX;